import React, { useState } from 'react';
import ConfirmDialog from '../../shared/ConfirmDialog';
import ShipConfirmFields, { blankShipFields } from './ShipConfirmFields';
import { carriagePayload } from './ShipmentCarriageFields';
import { detailsPayload, detailsDraft } from './packageShared';

// What a Ship pass sends, from ShipConfirmFields' value — shared with
// ShipmentsTable's Add Shipment drawer. Each ticked package goes with its
// own details (issue #313) and actual postage, inc GST (issue #350).
export function shipPayload(fields) {
  const postage = (id) => {
    const v = (fields.postage || {})[id];
    return v === undefined || v === '' ? null : v;
  };
  return {
    packages: (fields.package_ids || []).map((id) => ({
      id: Number(id),
      ...detailsPayload((fields.details || {})[id] || detailsDraft(null)),
      actual_postage_inc_gst: postage(id),
    })),
    shipped_date: fields.shipped_date || null,
    tracking_number: fields.tracking_number.trim(),
    ...carriagePayload(fields),
  };
}

// Every Ship action, wherever it's triggered — SalesOrderPage's plain Ship
// button, PickOrderPage's Ship Order — stages through this same confirm
// dialog (unify-ship), so every Ship pass collects the same fields and
// always creates a shipment record (see fulfilmentService.ship), not only
// passes started from ShipmentsTable's own Add Shipment drawer. Mounted
// only while open (see both callers' `{open && (...)}`), so its own field
// state resets for free on every fresh open — no explicit reset needed.
// `order` is the order as last saved, of any type (issue #298) — its
// Carrier/Service/Options seed this shipment's own (issue #281). `lines`
// and `packages` are the order's lines and unshipped packages as
// /api/fulfilment returns them (issue #299). `orderDate` drives the Date
// Shipped soft warning (issue #292).
function ShipConfirmDialog({ open, onOpenChange, lines, packages, order, orderDate, shipping, onConfirm }) {
  const [fields, setFields] = useState(() => blankShipFields(order, packages));
  const chosenAny = (fields.package_ids || []).length > 0;


  return (
    <ConfirmDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Confirm Ship"
      description="The packages ticked below will be marked as shipped. Anything not in them can ship at a later date."
      footer={(
        <>
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            disabled={shipping}
            style={{ padding: '8px 14px', border: '1px solid #bfc8d6', color: '#5a6b85', background: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={() => onConfirm(shipPayload(fields))}
            disabled={shipping || !chosenAny}
            title={!chosenAny ? 'Tick the packages that are shipping' : undefined}
            style={{ padding: '8px 14px', border: 'none', color: '#fff', background: chosenAny ? '#1e7e34' : '#c7ccd4', borderRadius: 6, cursor: chosenAny ? 'pointer' : 'not-allowed', fontSize: 13, fontWeight: 600 }}
          >
            {shipping ? 'Shipping...' : 'Confirm Ship'}
          </button>
        </>
      )}
    >
      <ShipConfirmFields lines={lines} packages={packages} value={fields} onChange={setFields} orderDate={orderDate} />
    </ConfirmDialog>
  );
}

export default ShipConfirmDialog;
